import { AbiParameter, parseAbiParameters } from 'viem';
import { SignatureType } from '../constants';
import { apiClient } from '../lib/apiClient';

export type SignTypedDataTypes = Record<SignatureType, readonly AbiParameter[]>;

export const getSpecificSignatureType = (signDataTypes: SignTypedDataTypes, key: SignatureType) => {
  const type = signDataTypes[key];
  return { [key]: type };
};
export const useDataForSigning = () => {
  const {
    data: rpcConfig,
    error: rpcConfigError,
    isPending: isPendingRpcConfig,
  } = apiClient.useQuery('get', '/v1/rpc/config', undefined, { staleTime: Infinity });

  const { domain, signatureTypes } = rpcConfig ?? {};
  const signedTypedDataTypes = signatureTypes
    ? ({
        [SignatureType.LINK_SIGNER]: parseAbiParameters(signatureTypes[SignatureType.LINK_SIGNER]),
        [SignatureType.REVOKE_LINKED_SIGNER]: parseAbiParameters(
          signatureTypes[SignatureType.REVOKE_LINKED_SIGNER]
        ),
        [SignatureType.TRADE_ORDER]: parseAbiParameters(signatureTypes[SignatureType.TRADE_ORDER]),
        [SignatureType.INITIATE_WITHDRAW]: parseAbiParameters(
          signatureTypes[SignatureType.INITIATE_WITHDRAW]
        ),
        [SignatureType.CANCEL_ORDER]: parseAbiParameters(
          signatureTypes[SignatureType.CANCEL_ORDER]
        ),
      } satisfies SignTypedDataTypes)
    : undefined;

  return {
    signedTypedDataTypes,
    domain: domain,
    error: rpcConfigError,
    isPending: isPendingRpcConfig,
  };
};

export const useExchangeAddress = () => {
  const { domain, isPending, error } = useDataForSigning();
  return { address: domain?.verifyingContract, isPending, error };
};
